module.exports = __webpack_public_path__ + "img/storage1.fa528e7f.png";